import React from 'react';

import ChildhoodLogo from '../../assets/childhood-logo-black.svg';

import './styles.css';

const LogoBar = () => {
    return (
        <div className='ncs-logo-bar'>
            <img src={ChildhoodLogo} alt='Childhood Brasil' />
            <span>Navegar com Segurança</span>
        </div>
    );
};

export default LogoBar;
